var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown",on:{"click":function($event){$event.stopPropagation();_vm.showOptions = !_vm.showOptions}}},[_c('div',{staticClass:"trigger"},[_vm._t("trigger")],2),_vm._v(" "),_c('transition',{attrs:{"name":"dropdown"}},[(_vm.showOptions)?_vm._t("options"):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }